const SET_LINEALCHANNEL_HAS_AN_ERROR = 'SET_LINEALCHANNEL_HAS_AN_ERROR';
const SET_LINEALCHANNEL_SUCCESS = 'SET_LINEALCHANNEL_SUCCESS';

export { SET_LINEALCHANNEL_HAS_AN_ERROR, SET_LINEALCHANNEL_SUCCESS };
